module.exports = __webpack_public_path__ + "static/media/meme.3fcad21f.svg";